import React, { useState } from "react";
import { Typography } from "@mui/material";
import {
  ICredentialsPickitErrors,
  ICredentialsPickitPayload,
  ICredentialsStep,
} from "../../../interfaces/configuration";
import { IValidation } from "../../../interfaces/form";
import { ERRORS_MESSAGES } from "../../../utils/constants";
import { validateInputs } from "../../../utils/inputValidations";
import CredentialsPickit from "../../forms/CredentialsPickit";
import ConfirmChangesCredentials from "../../configuration/ConfirmChangesCredentials";
import GenericForm from "../../GenericForm";
import GenericAlert from "../../GenericAlert";

const { pickitTokenRequired, pickitApikeyRequired } = ERRORS_MESSAGES;

const formValidations: IValidation[] = [
  {
    id: "token",
    type: "required",
    message: pickitTokenRequired,
  },
  {
    id: "apikey",
    type: "required",
    message: pickitApikeyRequired,
  },
];

const PickitCredentials = ({
  handleCancel,
  loading,
  alert,
  carrier,
  handleSubmitCarriers,
}: ICredentialsStep) => {
  const [credentials, setCredentials] = useState(
    {} as ICredentialsPickitPayload
  );
  const [errors, setErrors] = useState({} as ICredentialsPickitErrors);

  const handleSubmit = () => {
    const inputErrors = validateInputs(credentials, formValidations);
    setErrors(inputErrors);
    if (Object.keys(inputErrors).length === 0) {
      handleSubmitCarriers([
        {
          ...carrier,
          credentials,
        },
      ]);
    }
  };

  return (
    <>
      <Typography className="f-s-24 m-b-20">Credenciales de PICKIT</Typography>
      {alert.showAlert && <GenericAlert alert={alert} />}
      <GenericForm onSubmit={handleSubmit}>
        <CredentialsPickit
          values={credentials}
          setValues={setCredentials}
          errors={errors}
        />
      </GenericForm>
      <ConfirmChangesCredentials
        onClose={handleCancel}
        handleSubmit={handleSubmit}
        disabled={loading}
        backText="Cambiar operador"
        confirmText="Finalizar"
      />
    </>
  );
};

export default PickitCredentials;
